import SkooldioVideoBox from './SkooldioVideoBox';

export default SkooldioVideoBox;
